import styled from 'styled-components';

import PlainCard from '~atoms/PlainCard';

export const containerPadding = '10rem';

export const Container = styled(PlainCard)(({ theme }) => ({
  padding: containerPadding,

  color: theme.palette.erieBlack,
  fontFamily: theme.typography.family.arial,
  fontSize: theme.typography.size14,

  p: {
    marginBlock: '10rem',
  },
}));

export const Img = styled.img({
  width: '100%',
  height: '150rem',
  borderRadius: '10rem',
  objectFit: 'contain',
});

export const Btn3DModal = styled.button({
  position: 'absolute',
  right: '30rem',
  bottom: '10rem',

  backgroundColor: 'transparent',
  border: 'none',

  cursor: 'pointer',
});

export const ImgContainer = styled.div({
  position: 'relative',
  '&[draggable="true"]': {
    cursor: 'grab',
  },
  '&[draggable="true"]:active': {
    cursor: 'grabbing',
  },
});

export const Title = styled.p(({ theme }) => ({
  margin: 0,

  fontSize: theme.typography.size16,
}));

export const Tooltip = styled.div(({ theme }) => ({
  height: '20rem',
  width: '100%',
  position: 'absolute',
  left: 0,
  top: '60rem',
  textAlign: 'center',
  background: `${theme.palette.white}80`,
  paddingBlock: '5rem',
  userSelect: 'none',
  pointerEvents: 'none',
}));

export const OnTrend = styled.div(({ theme }) => ({
  background: theme.defaultTheme.trendColor,
  position: 'absolute',
  top: '5rem',
  padding: '0 10rem',
  color: theme.palette.white,
  fontSize: '12rem',
}));
